import React from 'react';
interface ChipGroupProps {
  label: string;
  options: string[];
  selected: string[];
  onToggle: (value: string) => void;
  hint?: string;
}
export function ChipGroup({
  label,
  options,
  selected,
  onToggle,
  hint
}: ChipGroupProps) {
  return <fieldset className="flex flex-col space-y-3" data-id="element-55" data-mp="3utlqp8wf8nn4">
      <legend className="text-sm font-medium text-engage-gray5" data-id="element-56" data-mp="3halklijfse1">
        {label}
        {hint && <span className="text-engage-gray4 font-normal" data-id="element-57" data-mp="8gx2p61hlss4"> — {hint}</span>}
      </legend>
      <div className="flex flex-wrap gap-2" data-id="element-58" data-mp="defb8vble5zl">
        {options.map(option => {
        const isSelected = selected.includes(option);
        return <button key={option} type="button" aria-pressed={isSelected} onClick={() => onToggle(option)} className={`px-4 py-2 rounded-full text-sm font-medium border transition-colors duration-200 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-engage-yellow focus-visible:ring-offset-2 focus-visible:ring-offset-engage-gray1 ${isSelected ? 'bg-engage-yellow text-engage-black border-engage-yellow' : 'bg-engage-gray2 text-engage-gray5 border-engage-gray3 hover:border-engage-yellow/60 hover:text-engage-white'}`} data-id="element-59" data-mp="hez9y3btdhnu">
              {option}
            </button>;
      })}
      </div>
    </fieldset>;
}